export default "__VITE_ASSET__BGFxY9_o__"